import {Alert, Button} from 'antd'
import {billing_getStaticFeaturesOfClass_Api, billing_selectSubscription_Api} from 'apis'
import _ from 'lodash'
import {createAsyncAction} from 'modules/asyncCache'
import useAsync from 'modules/asyncCache/useAsync'
import useDispatchAsyncActionWithNotify from 'modules/asyncCache/useDispatchAsyncActionWithNotify'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React from 'react'
import {Link, useParams} from 'react-router-dom'
import {links} from '../routes'
import {APP_NAME} from "../../../envs/_current/config";
import {emptyObject} from "../../../helpers/emptyObjects";

export const ConfirmDowngradePlan = () => {
  const { planId } = useParams()
  const {
    response,
    isLoading
  } = useAsync({
    apiInfo: billing_getStaticFeaturesOfClass_Api
  })
  const plans = _.get(
    response,
    'data.data',
    []
  )
  const plan =
    plans.find(
      item => item.id == planId
    ) || emptyObject
  const history = useHistory()
  const [
    data,
    dispath
  ] = useDispatchAsyncActionWithNotify({
    onSuccess: () =>
      history.push(
        links.manageSubscriptions
      )
  })
  const t = useTranslate()
  return (
    <div
      style={{ fontWeight: 500 }}
      className="w-full text-gray-800 verticalList__large max-w-md mx-auto ">
      <h2 className="text-4xl text-center block font-bold">
        {t('downgrade')}
      </h2>
      <div className="verticalList__small">
        <h2 className="text-2xl font-bold">
          <span className="text-color-300">
            {t(
              'downgrade your subscription to'
            )}
          </span>{' '}
          {plan.name}
        </h2>
        <Alert
          type="warning"
          showIcon
          message={
            <div>
              {t(
                'Your current active subscription package will continue to hold until it expires'
              )}
            </div>
          }
        />
      </div>
      <div className="text-color-300 text-sm">
        {t(
          `By clicking Submit, you agree to the policy of ${APP_NAME} {term1} and {term2}.`,
          {
            term1: (
              <a
                className="hover:underline color-primary"
                href="#">
                {t('terms of service')}
              </a>
            ),
            term2: (
              <a
                className="hover:underline color-primary"
                href="#">
                {t('privacy policy')}
              </a>
            )
          }
        )}
      </div>
      <div className="flex justify-end">
        <Link to={links.changePlan}>
          <Button
            type="ghost"
            className="mr-3">
            {t('back')}
          </Button>
        </Link>
        <Button
          onClick={() => {
            dispath(
              createAsyncAction({
                apiInfo: billing_selectSubscription_Api,
                query: {
                  ':code': planId
                }
              })
            )
          }}
          type="primary">
          {t('submit')}
        </Button>
      </div>
    </div>
  )
}

export default ConfirmDowngradePlan
